import { MdAltRoute } from 'react-icons/md'
import { IResourceConfig } from '@/Core/Contracts/UI'
import { LinkFieldTemplate } from '@/Ship/Templates/Form/LinkFieldTemplate'

export const TypicalRouteResource: IResourceConfig = {
    title: 'Типові маршрути',
    pageConfig: {
        title: 'Типові маршрути',
        icon: <MdAltRoute />,
    },
    /**
     * Дати й автори створення/зміни не описані полями: їх показує «Службова інформація»
     * (DetailShell) з даних картки, а стандартна форма ядра вивела б їх ще раз
     */
    fields: {
        id: {
            label: 'ID',
            type: 'number',
            inputProps: {
                disabled: true,
            },
            /** У фільтрі: оператор (=, >, ≥, <, ≤) або діапазон від–до */
            isFilterRange: true,
        },
        title: {
            label: 'Назва',
            isRequired: true,
            type: 'string',
        },
        loadingPoint: {
            label: 'Пункт навантаження',
            type: 'select',
            isRequired: true,
            resource: 'Setting.ListLoadingPoint',
            inputProps: {
                filter: {
                    isActive: true,
                },
            },
        },
        unloadingPoint: {
            label: 'Пункт розвантаження',
            type: 'select',
            isRequired: true,
            resource: 'Setting.ListLoadingPoint',
            inputProps: {
                filter: {
                    isActive: true,
                },
            },
        },
        routeUrl: {
            label: 'Маршрут (посилання)',
            type: 'string',
            isRequired: true,
            /** У перегляді — посилання в новій вкладці */
            template: LinkFieldTemplate,
        },
        priority: {
            label: 'Пріоритет',
            type: 'number',
            defaultValue: 0,
        },
    },
    filter: {
        includeFields: ['id', 'title', 'loadingPoint', 'unloadingPoint'],
    },
    table: {
        showColumns: ['title', 'loadingPoint', 'unloadingPoint', 'priority'],
        scroll: { x: 'max-content' },
    },
    restUrl: '/services/typical-routes',
    pageUrl: '/transport/typical-routes',
    settings: {
        searchFields: ['id', 'title'],
    },
}
